// src/api/widgetService.js

// Import the newly created specific services
import { widgetTemplateService } from './widgetTemplateService';
import { widgetVersionService } from './widgetVersionService';

// Combine and re-export all methods under a single widgetService object
export const widgetService = {
  // --- Template Methods ---
  ...widgetTemplateService,

  // --- Version Methods ---
  ...widgetVersionService,
};